import { trackLink } from '@99designs/common/utils/platform';
import initHowItWorksSteps from 'marketing/components/PartnershipHowItWorks';
import createScrollableElements, {
    centerAlignScrollableElement,
    scrollOnHover,
} from 'marketing/components/scrollable';
import Accordion from './components/Accordion';
import createHowItWorksCarousel from './components/hiw-carousel';
import SlideCarousel from './components/slide-carousel';
import StickyBar from './components/StickyBar';

document.addEventListener('DOMContentLoaded', () => {
    Accordion.create();
    SlideCarousel.create();

    createScrollableElements();
    scrollOnHover('[data-scrollable="featured-designs"]');
    centerAlignScrollableElement('[data-scrollable="featured-designs"]');

    // tslint:disable-next-line:no-unused-expression
    new StickyBar();

    initHowItWorksSteps();

    createHowItWorksCarousel(document.querySelector('[data-hiw]'));

    initTrackCTA();
});

function initTrackCTA() {
    const ctaElements = document.querySelectorAll('[data-tracking-download]');

    Array.from(ctaElements).forEach(element => {
        if (element.getAttribute('data-tracking-download') !== 'true') {
            return;
        }

        const url = (element.getAttribute('href') || '').trim();

        if (!url) {
            return;
        }

        const filename = url.split('/').pop();
        const fileType = (filename as string).split('.').pop();
        const location = window.location.pathname.substring(1);

        trackLink(element, 'File Downloaded', {
            location,
            file_name: filename,
            file_type: fileType,
        });
    });
}
